/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { featureFlagSchema } from '../schemas';

export const listFeatureFlagsDataSchema = z.array(featureFlagSchema);

export type IListFeatureFlagsData = z.infer<typeof listFeatureFlagsDataSchema>;

export const listFeatureFlagsResponseSchema = createApiResponseSchema(
  listFeatureFlagsDataSchema,
) as z.ZodSchema<IAPI<IListFeatureFlagsData>>;

export type IListFeatureFlagsResponse = IAPI<IListFeatureFlagsData>;
